import React from 'react';
import {BaseModal} from '../../comun/Index';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      documento:"",
      nombre:"",
      user:"",
      mail:"",
      tipo_usuario_id:1,
      localidad_id:0
    }
  }
  componentDidMount(){
    if (this.props.datos !== undefined){
      this.setState(JSON.parse(JSON.stringify(this.props.datos)));
    }
    this.setState({idLocalidad:this.props.localidades[0].id})
  }

  render(){
    const {documento, nombre, user, mail, tipo_usuario_id, localidad_id} = this.state;
    const {localidades} = this.props;
    return(
      <BaseModal
        titulo="Datos de Usuario"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.props.guardar(this.state)}
        ]}
      >
        <div className="Seccion">
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({documento:e.target.value})}
            value={documento}
            placeholder="Documento"
          />
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({nombre:e.target.value})}
            value={nombre}
            placeholder="Nombre completo"
          />
        </div>
        <div className="Seccion">
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({mail:e.target.value})}
            value={mail}
            placeholder="eMail"
          />
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({user:e.target.value})}
            value={user}
            placeholder="Usuario"
          />
        </div>
        <div className="Seccion">
          <select
            onChange={(e)=>this.setState({tipo_usuario_id:e.target.value})}
            value={tipo_usuario_id}
            style={{marginRight:5}}
          >
            <option value={1}>Agente</option>
            <option value={2} disabled>Administrador</option>
          </select>
          <select
            onChange={(e)=>this.setState({localidad_id:e.target.value})}
            value={localidad_id}
            style={{marginLeft:5}}
          >
            {localidades.map((item, index) => {
              return(
                <option value={item.id} key={index}>{item.descripcion}</option>
              )
            })}
          </select>
        </div>
      </BaseModal>
    );
  }
}

export default Nueva;
